/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export * from './api/base';
export * from './api/base-adapter';
export * from './responsive/responsive-activation';
export * from './_module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/~/@angular/flex-layout/flexbox/index.js
// module id = ../../../flex-layout/flexbox/index.js
// module chunks = 3